import { render } from "./AdminsRelacionadosList.vue?vue&type=template&id=100140c4"
import script from "./AdminsRelacionadosList.vue?vue&type=script&lang=js"
export * from "./AdminsRelacionadosList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__